module.exports = __webpack_public_path__ + "static/media/13.1bbd5847.jpg";